import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { CYCLONE_GRADE_COLORS, CYCLONE_INTENSITY_MAPPING, EQ_MAGNITUDE_BANDS, EQ_ZONE_COLOR, NHIP_HIERARCHY, NHIP_LAYER_LIST, NHIP_LEGENDS } from './nhip-home-map-constants';
import { AgricultureMapConstants, LAYER_TYPES } from 'src/app/main/constants/dims-map-constants';
import { UtilsService } from 'src/app/utils/utils.service';
import * as L from 'leaflet';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { environment } from 'src/environments/environment';
import { isEmptyObject } from 'jquery';
import cloneLayer from 'leaflet-clonelayer';
import { pixiPopupTable } from 'src/app/main/shared/pixi/pixi-points-layer';

@Injectable({
  providedIn: 'root'
})
export class NhipHomeMapService {

  selectedHazard: any = null
  infoBoxDataObj: any;
  CQL_FILTER_MAPPING: any = {
    'Last 10 Years': 10,
    'Last 20 years': 20,
    'All Historical': 'All'
  }

  constructor(private utils: UtilsService,
    private http: HttpClient,  // ADD THIS
    private errorHandler: HttperrorhandlerService, // ADD THIS
  ) { }

  getSrcWiseLayers(gisMapComp: any) {
    // gisMapComp.labelStrings = []
    gisMapComp.map.closePopup()
    // gisMapComp.toggleButtons.overlaylayerControl = false;
    let queryParams: any = gisMapComp['queryParams']['params'];
    // gisMapComp.otherOptions.showNgxPlaybar = queryParams.fogView == 'forecast' && queryParams.format == 'HOURLY' ? true : false
    gisMapComp.selectedSource = queryParams['source']
    if (!isNullOrUndefined(queryParams) && Object.keys(queryParams).length > 0) {
      if (queryParams.hazardView != 'locationInfo') {
        gisMapComp.showMapThrobber = true;
        if (!gisMapComp.basemapInitialized) {
          gisMapComp.getAndSetBaseLayers(3) // for dark background
          gisMapComp.basemapInitialized = true;
        }
        let layerList: any = {}
        let layerName: any;
        let hie = NHIP_HIERARCHY
        layerName = gisMapComp.gisUtils.titleCase(hie[hie.indexOf(queryParams.locType) + 1])
        layerList[layerName + ' Boundary'] = NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary']
        if (layerName != 'State') {
          layerList[layerName + ' Boundary Labels'] = NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary Labels']
        }
        // if (queryParams.locType != 'COUNTRY') {
        layerList[gisMapComp.gisUtils.titleCase(queryParams.locType)] = NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][gisMapComp.gisUtils.titleCase(queryParams.locType) + ' Boundaries'];
        // Cyclone Line gets wiped from the map on location drilldown; re-add it here if it was checked in the Cyclones section so it doesn't disappear.
        // Scoped to cyclone-relevant hazard views only, otherwise a stale activeLayers flag would re-render it after switching to a different hazard (e.g. Earthquake).
        if (gisMapComp.activeLayers && gisMapComp.activeLayers['Cyclone Line'] && !gisMapComp.isLocationOnlyMode) {
          layerList['Cyclone Line'] = NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Cyclone Line'];
        }
        this.addSrcWiseGeoJSONLayers(gisMapComp, layerList)
        // }
        /*Adding mask layer */
        layerList = gisMapComp.gisdataService.addMaskLayer(layerList, queryParams, gisMapComp.params.component)
        this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams)
        this.addSrcWiseWMSLayers(layerList, gisMapComp, queryParams);
        if (queryParams.locType != 'COUNTRY') {
          let infoObj = JSON.parse(localStorage.getItem('infoObj'))
          if (!isEmptyObject(infoObj)) {
            this.utils.setViewForNHIPAlert.next(infoObj)
          }
        }
        gisMapComp.otherOptions.onLocationClick = true
        setTimeout(() => {
          // gisMapComp.showThrobber = false
          gisMapComp.showMapThrobber = false
        }, 2000)
      } else {
        gisMapComp.getAndSetBaseLayers(3)
        this.loadLocationOnlyMap(gisMapComp)
      }
    }
  }

  addSrcWiseGeoJSONLayers(gisMapComp: any, layerList: any) {
    let geoJsonLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.GEOJSON_LAYER);
    // geoJsonLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, geoJsonLayersBasedOnView);
    geoJsonLayersBasedOnView = this.formatLayersData(gisMapComp, geoJsonLayersBasedOnView);
    // console.log('checking geosjson:::', geoJsonLayersBasedOnView);
    gisMapComp.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView);

  }

  formatLayersData(gisMapComp: any, layerList: any) {
    for (let layerName in layerList) {
      if (layerName != 'Country') {
        if (layerList[layerName].layerOptions.cql_filter_value) {
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + gisMapComp.queryParams.params['pUUID'] + "'";
        }
      } else if (layerName == 'Country') {
        layerList[layerName].layerOptions.cql_filter = '1=1'
      }
      if (layerName == 'Cyclone Line') {
        layerList[layerName].layerOptions.cql_filter = this.getTimeRangeCql(gisMapComp.timerange);
      }
    }
    return layerList;
  }

  async addSrcWiseVectorLayers(layerList: any, gisMapComp: any, queryParams: any) {
    // console.log(layerList, "vectorLayersBasedOnView");
    let vectorLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);

    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        vectorLayersBasedOnView = this.formatVectorLayersData(vectorLayersBasedOnView, queryParams, gisMapComp);
      }
    }
    this.setVectorLayerStyles(vectorLayersBasedOnView, gisMapComp);
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
    // this.addLegend(gisMapComp)
  }

  addSourceWiseLayers(gisMapComp: any, layerList?: any, params?: any, queryParams?: any) {
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }

  formatVectorLayersData(layerList: any, queryParams?: any, gisMapComp?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        let uuid: any = queryParams['pUUID'];
        if (queryParams.locType == 'COUNTRY' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams['locType'] == 'STATE' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'state_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'DISTRICT' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'dist_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
      }
      return layerList;
    }
  }

  async addSrcWiseWMSLayers(layerList: any, gisMapComp: any, queryParams: any) {
    let wmsLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, wmsLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        wmsLayersBasedOnView = this.formatWmsLayersData(gisMapComp, wmsLayersBasedOnView, queryParams);
      }
    }
    gisMapComp.addSrcWiseWMSLayers(wmsLayersBasedOnView);
  }

  addSrcWisePixiLayers(layerList: any, gisMapComp: any) {
    let pixiLayersBasedOnView: any = {};
    for (let layerName in layerList) {
      if (layerList[layerName].type == LAYER_TYPES.PIXI_LAYER) {
        pixiLayersBasedOnView[layerName] = layerList[layerName];
      }
    }
    pixiLayersBasedOnView = this.formatPixiLayersData(gisMapComp, pixiLayersBasedOnView);
    gisMapComp.addSrcWisePIXILayers(pixiLayersBasedOnView);
  }

  // Returns copies so the shared NHIP_LAYER_LIST entries are never mutated
  formatPixiLayersData(gisMapComp: any, layerList: any) {
    let formatted: any = {};
    for (let layerName in layerList) {
      let layer: any = { ...layerList[layerName] };
      if (layer.time_filter_field) {
        layer.cql_filter = this.getTimeRangeCql(gisMapComp.timerange, layer.time_filter_field);
      }
      formatted[layerName] = layer;
    }
    return formatted;
  }

  // 'Last 10 Years' -> "year >= 2016"; 'All Historical' (or no range yet) -> no restriction
  getTimeRangeCql(timerange: any, yearField: string = 'year') {
    let yearsBack = this.CQL_FILTER_MAPPING[timerange];
    if (!yearsBack || yearsBack == 'All') {
      return '1=1';
    }
    return `${yearField} >= ${new Date().getFullYear() - yearsBack}`;
  }

  // formatWmsLayersData(layerList: any, queryParams?: any) {
  //   if (!isNullOrUndefined(queryParams)) {
  //     for (let layerName in layerList) {
  //       if (queryParams.locType == 'DISTRICT') {
  //         let allLocations = queryParams.location.split('&')
  //         let districtUUID = allLocations[2].split('##')[1]
  //         if (layerList[layerName].layerOptions.cql_filter_value) {
  //           layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + districtUUID + "'";
  //         }
  //       }
  //       if (layerName.includes('world_view')) {
  //         let uuid: any = queryParams.pUUID;
  //         if (!isNullOrUndefined(queryParams.type)) {
  //           layerList[layerName].layerOptions.cql_filter = queryParams.locType == 'VILLAGE' ? '1=1;village_uuid' + "='" + uuid + "'" : '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
  //         } else {
  //           layerList[layerName].layerOptions.cql_filter = '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
  //         }
  //       }
  //     }
  //     return layerList;
  //   }
  // }
  formatWmsLayersData(gisMapComp: any, layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        if (queryParams.locType == 'STATE' || queryParams.locType == 'DISTRICT') {
          let allLocations = queryParams.location.split('&')
          let locUUID = queryParams.locType == 'DISTRICT' ? allLocations[2].split('##')[1] : allLocations[1].split('##')[1]
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + locUUID + "'";
          }
        }
        // ADD THIS BLOCK FOR BLOCK LEVEL SUPPORT
        if (queryParams.locType == 'BLOCK') {
          let allLocations = queryParams.location.split('&')
          let blockUUID = allLocations[3].split('##')[1]
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + blockUUID + "'";
          }
        }
        if (layerName.includes('world_view')) {
          let uuid: any = queryParams.pUUID;
          if (!isNullOrUndefined(queryParams.type)) {
            layerList[layerName].layerOptions.cql_filter = queryParams.locType == 'VILLAGE' ? '1=1;village_uuid' + "='" + uuid + "'" : '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          } else {
            layerList[layerName].layerOptions.cql_filter = '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          }
        }
        if (layerName == 'Cyclone Line') {
          layerList[layerName].layerOptions.cql_filter = this.getTimeRangeCql(gisMapComp.timerange);
        }
      }
      return layerList;
    }
  }

  // addLegend(gisMapComp) {
  //   for (const key in FOG_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA]) {
  //     gisMapComp['legendList'][key] = FOG_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA][key];
  //   }
  //   gisMapComp.manageLegend();
  // }

  handleAdminPolygons(layer: any, mapObj: any, params: any, gisMapComp: any) {
    let queryParams: any = gisMapComp['queryParams']['params'];
    layer.setStyle({
      color: queryParams.hazardView != 'locationInfo' ? '#00ffff' : '#000000',
      fill: false,
      weight: 1.5,
    });
  }

  setVectorLayerStyles(layerList: any, gisMapComp: any) {
    const self = this;
    for (let key in layerList) {
      let layerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
      layerList[key].layerOptions.vectorTileLayerStyles[layerName] = function (properties: any) {
        let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
        let currentLevel: any = hie[hie.indexOf(gisMapComp.queryParams.params.locType) + 1];
        let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.queryParams.params.locType) + ' ' + 'Boundaries';
        gisMapComp.map.eachLayer((layer: any) => {
          if (layer.options.layer_name === levelBoundary) {
            if (gisMapComp.map.hasLayer(layer)) {
              gisMapComp.map.removeLayer(layer);
            }
          }
        });
        let zoneColor;
        // console.log(properties,"properties");
        let style: any;
        // if (currentLevel == 'STATE' && key == 'District Boundary') {
        //   style = {
        //     color: '#000000',
        //     fill: false,
        //     weight: 0.25
        //     // opacity: 1,
        //     // fillColor: 'transparent',
        //     // fillOpacity: 0.5
        //   }
        // } else {
        if (key == 'Zones') {
          zoneColor = self.getEQZoneColor(properties.EQ_Zone)
          style = {
            color: '#000000',
            fill: true,
            weight: 1,
            // opacity: 1,
            fillColor: zoneColor,
            fillOpacity: 1
          }
        } else {
          style = {
            color: '#000000',
            fill: false,
            weight: 0.25,
            // opacity: 1,
            // fillColor: 'transparent',
            // fillOpacity: 0.5
          }
        }
        return style
      }
    }
  }

  getEQZoneColor(val: any) {
    return EQ_ZONE_COLOR[val]
  }

  handleHazardLayers(gisMapComp: any, layerName: any, queryParams: any, layerNameList: any) {
    // if (gisMapComp.route.snapshot.queryParams['locationOnly'] === 'true') {
    //   console.log(' Location mode - skipping hazard layers');
    //   return;
    // }
    if (gisMapComp.isLocationOnlyMode) {
      console.log(' Location mode - skipping hazard layers');
      return;
    }

    // Invalidate any hazard-layer fetch still in flight from a previous selection (e.g. a
    // Cyclone Line WFS request) so it can detect it's stale and skip re-adding itself below.
    gisMapComp.hazardRequestToken = (gisMapComp.hazardRequestToken || 0) + 1;

    this.removeExistingLayers(gisMapComp, layerNameList)

    // Support both single layer name (string) and multiple layer names (array)
    const layerNames = Array.isArray(layerName) ? layerName : [layerName];

    // Clear the active flag for any layer that belonged to the previous hazard type but isn't part of
    // the current selection (e.g. Cyclone Line/Point after switching from Cyclone/Multi Hazard to Earthquake),
    // otherwise stale flags elsewhere can cause it to be re-rendered on a later map refresh.
    layerNameList.forEach((name: any) => {
      if (!layerNames.includes(name)) {
        gisMapComp.activeLayers[name] = false;
      }
    });

    let layerList: any = {}
    // Add all requested layers to the layerList
    layerNames.forEach(name => {
      if (NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][name]) {
        layerList[name] = NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][name];
      }
    });

    // Clear existing legends
    gisMapComp.legendList = {};

    // Populate legendList for selected layers
    layerNames.forEach(name => {
      if (NHIP_LEGENDS[name]) {
        // console.log(layerNames,"layer names");

        gisMapComp.legendList[name] = NHIP_LEGENDS[name];
      }
      gisMapComp.activeLayers[name] = true;
    });

    this.addSrcWiseWMSLayers(layerList, gisMapComp, queryParams)
    this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams);
    this.addSrcWiseGeoJSONLayers(gisMapComp, layerList);
    this.addSrcWisePixiLayers(layerList, gisMapComp);

    // Trigger legend update after layers are added
    setTimeout(() => {
      gisMapComp.manageLegend();
    }, 500);
  }

  removeExistingLayers(gisMapComp: any, layerNameList: any) {
    for (let index in layerNameList) {
      let layerName = layerNameList[index]
      if (gisMapComp.layers.overlaylayers[layerName] && gisMapComp.map.hasLayer(gisMapComp.layers.overlaylayers[layerName])) {
        gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers[layerName])
      }
    }
  }

  setInfoboxData(properties: any, gisMapComp: any) {
    // Try to determine the level based on available properties
    const blockName = properties.block_name;
    const districtName = properties.dist_name
    const stateName = properties.state_name
    // const isDistrict = !!districtName;
    //   const locName = isDistrict ? districtName : stateName;
    const lat = properties.latitude
    const lng = properties.longitude

    let obj: any = {
      lat,
      lng
    };
    if (blockName) {
      obj.locName = blockName;
      obj.locType = 'BLOCK';
      obj.blockUUID = properties.uuid;
    } else if (districtName) {
      obj.locName = districtName;
      obj.locType = 'DISTRICT';
      obj.districtUUID = properties.uuid;
    } else if (stateName) {
      obj.locName = stateName;
      obj.locType = 'STATE';
      obj.stateUUID = properties.uuid;
    }
    localStorage.setItem('infoObj', JSON.stringify(obj))
    this.utils.setViewForNHIPAlert.next(obj)
    if (!gisMapComp.dataTabToggleVal) {
      gisMapComp.dataTabToggle()
    }
  }

  // Pixi colour for a Cyclone Point (see pixi_color in NHIP_LAYER_LIST); grades not in the legend are hidden
  getCyclonePointColor(props: any) {
    return CYCLONE_GRADE_COLORS[String(props.grade || '').toUpperCase()] || null;
  }

  getCyclonePointPopup(props: any) {
    const grade = String(props.grade || '');
    const gradeKey = Object.keys(CYCLONE_INTENSITY_MAPPING).find(key => key.toUpperCase() == grade.toUpperCase());
    return pixiPopupTable(props.name || 'Cyclone Point', [
      ['Grade', gradeKey ? `${CYCLONE_INTENSITY_MAPPING[gradeKey]} (${grade})` : grade],
      ['Observed', props.obs_time ? String(props.obs_time).replace('T', ' ') : null],
      ['Wind Speed', props.kt != null ? `${props.kt} kt` : null],
      ['Pressure', props.ecp != null ? `${props.ecp} hPa` : null],
      ['Basin', props.basin]
    ]);
  }

  getNearestHazardsByPoint(postData: any) {
    // console.log('📡 NhipHomeMapService.getNearestHazardsByPoint called with:', postData);

    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + '/nhip/getNearestHazardsByPoint',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Point hazard request', {
        zones: { wind: 0, earthquake: 0 },
        hazards: {
          earthquake: {
            nearestEarthquakePoint: null,
            nearestFaultLine: null
          },
          cyclone: {
            distanceKm: 0,
            eventTime: 0,
            cycloneName: null,
            nearestPoint: null,
            geometry: null
          }
        }
      }))
    );
  }
  getLocationByPoint(postData: any) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + '/api/nhip/getLocationByPoint',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Location by point request', null))
    );
  }
  // Pixi colour for an earthquake from the Magnitude legend bands. Bands are treated as contiguous, so a
  // value in the gap between one band's max and the next band's min (e.g. 4.505) takes the lower band;
  // magnitudes outside the legend altogether are hidden.
  getEarthquakePointColor(props: any) {
    const mag = parseFloat(props.mag);
    const lastBand = EQ_MAGNITUDE_BANDS[EQ_MAGNITUDE_BANDS.length - 1];
    if (isNaN(mag) || mag > lastBand.max) {
      return null;
    }
    let color: string = null;
    EQ_MAGNITUDE_BANDS.forEach(band => {
      if (mag >= band.min) {
        color = band.color;
      }
    });
    return color;
  }

  getEarthquakePointPopup(props: any) {
    return pixiPopupTable(props.place || 'Earthquake', [
      ['Magnitude', props.mag != null ? `${props.mag} ${props.magtype || ''}`.trim() : null],
      ['Depth', props.depth != null ? `${props.depth} km` : null],
      ['Time (UTC)', props.time]
    ]);
  }

  handleCycloneLines(feature, mapObj, params, gisMapComp) {
    // console.log(feature, "featureeeee");

    const timeRange = (gisMapComp.timerange || 'Last 10 Years');
    const cycloneTime = feature.properties.start_dt;
    //  feature.setStyle({
    //   color: '#000000',
    //   fill: false,
    //   weight: 1.5,
    // });

    return this.isCycloneLineTimeInRange(cycloneTime, timeRange);
  }
  handleCycloneLineStyle(feature) {
    return {
      color: '#003BB0',
      weight: 2,
      dashArray: '6,6',
      opacity: 1
    };
  }


  isCycloneLineTimeInRange(timeStr: string, timeRange: string): boolean {
    if (!timeStr || !timeRange || timeRange.toLowerCase() === 'all historical') {
      return true;
    }
    // Expected format: "1982-10-16T12:00:00"
    const eventYear = new Date(timeStr).getFullYear();
    const currentYear = new Date().getFullYear();
    let startYear: number;

    const rangeLower = timeRange.toLowerCase();

    if (rangeLower.includes('10 years')) {
      startYear = currentYear - 10;
    } else if (rangeLower.includes('20 years')) {
      startYear = currentYear - 20;
    } else {
      return true;
    }
    return eventYear >= startYear && eventYear <= currentYear;
  }


  getNearestFacilities(postData: any) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + '/nhip/getNearestFacilities',
      postData
    ).pipe(
      catchError(
        this.errorHandler.handleError('Nearest facilities request', null)
      )
    );
  }

  loadLocationOnlyMap(gisMapComp) {
    console.log(' Location Only Mode - Country Boundary');
    gisMapComp.isLocationOnlyMode = true;
    gisMapComp.map.eachLayer((layer: any) => {
      if (!(layer instanceof L.TileLayer)) {
        gisMapComp.map.removeLayer(layer);
      }
    });

    this.clearAllConnectionLines(gisMapComp);

    if (gisMapComp.layers.overlaylayers['clickedPointMarker']) {
      gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers['clickedPointMarker']);
      delete gisMapComp.layers.overlaylayers['clickedPointMarker'];
    }

    gisMapComp.removeAllLayers();

    if (gisMapComp.locationInfoControl) {
      gisMapComp.map.removeControl(gisMapComp.locationInfoControl);
      gisMapComp.locationInfoControl = null;
    }

    const existingPopup = document.getElementById('instruction-top-left');
    if (existingPopup) existingPopup.remove();

    // gisMapComp.getAndSetBaseLayers(3);

    const layerList = {
      'Country Boundaries': NHIP_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Country Boundaries']
    };

    this.addSrcWiseGeoJSONLayers(gisMapComp, layerList);
    // setTimeout(() => {
    //   gisMapComp.map.eachLayer((layer: any) => {
    //     // console.log('Layer type:', layer);
    //   });

    // }, 1000);


    const indiaBounds = L.latLngBounds([6.5, 68.0], [35.5, 97.5]);
    gisMapComp.map.fitBounds(indiaBounds);
    if (gisMapComp.htmlNewLegend) {
      gisMapComp.map.removeControl(gisMapComp.htmlNewLegend);
      gisMapComp.htmlNewLegend = null;
    }



    this.showLocationOnlyInfo(gisMapComp);
    this.addInstructionPopup(gisMapComp);
    this.setupPointClickHandler(gisMapComp);
    this.addPointMarkerStyles();
    gisMapComp.activeLayers = {};
    gisMapComp.legendList = {};
    gisMapComp.otherOptions.legend = {};

  }

  clearAllConnectionLines(gisMapComp) {
    this.teardownHazardLabelLayout(gisMapComp);
    Object.keys(gisMapComp.connectionLines).forEach(key => {
      if (gisMapComp.connectionLines[key]) {
        if (Array.isArray(gisMapComp.connectionLines[key])) {
          gisMapComp.connectionLines[key].forEach((item: any) => {
            if (item && item.line && gisMapComp.map.hasLayer(item.line)) {
              gisMapComp.map.removeLayer(item.line);
            }
            if (item && item.label && gisMapComp.map.hasLayer(item.label)) {
              gisMapComp.map.removeLayer(item.label);
            }
            if (item && item.icon && gisMapComp.map.hasLayer(item.icon)) {
              gisMapComp.map.removeLayer(item.icon);
            }
            if (item && item.leader && gisMapComp.map.hasLayer(item.leader)) {
              gisMapComp.map.removeLayer(item.leader);
            }
            if (item && item.iconLeader && gisMapComp.map.hasLayer(item.iconLeader)) {
              gisMapComp.map.removeLayer(item.iconLeader);
            }
            if (item && gisMapComp.map.hasLayer(item)) {
              gisMapComp.map.removeLayer(item);
            }
          });
        } else {
          if (gisMapComp.map.hasLayer(gisMapComp.connectionLines[key])) {
            gisMapComp.map.removeLayer(gisMapComp.connectionLines[key]);
          }
        }
        gisMapComp.connectionLines[key] = null;
      }
    });

    gisMapComp.connectionLines = {
      school: null,
      hospital: null,
      earthquake: null,
      cyclone: null,
      faultLine: null,
      schoolMarker: null,
      hospitalMarker: null,
      earthquakeMarker: null,
      cycloneMarker: null,
      faultGeometry: null
    };

    Object.keys(gisMapComp.layers.overlaylayers).forEach(key => {
      if (key.includes('line') || key.includes('connection') || key.includes('marker')) {
        if (gisMapComp.map.hasLayer(gisMapComp.layers.overlaylayers[key])) {
          gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers[key]);
        }
        delete gisMapComp.layers.overlaylayers[key];
      }
    });
  }

  // Update showLocationOnlyInfo to store the control
  showLocationOnlyInfo(gisMapComp) {
    // Remove existing info control if any
    if (gisMapComp.locationInfoControl) {
      gisMapComp.map.removeControl(gisMapComp.locationInfoControl);
    }

    gisMapComp.locationInfoControl = L.control({ position: 'bottomright' });
    gisMapComp.locationInfoControl.onAdd = () => {
      const div = L.DomUtil.create('div', 'info-box');
      div.innerHTML = `
        <div style="background: rgba(0,0,0,0.9); color: white; padding: 15px; border-radius: 8px; border-left: 5px solid #4CAF50; box-shadow: 0 2px 10px rgba(0,0,0,0.3);">
          <strong style="font-size: 14px;">📍 LOCATION ONLY VIEW</strong><br>
          <button onclick="window.location.href=window.location.href.split('?')[0]"
            style="margin-top: 10px; background: #4CAF50; color: white; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; width: 100%;">
            Exit Location View
          </button>
        </div>
      `;
      return div;
    };
    gisMapComp.locationInfoControl.addTo(gisMapComp.map);
  }

  addInstructionPopup(gisMapComp) {
    const existing = document.getElementById('instruction-top-left');
    if (existing) existing.remove();

    const mapContainer = gisMapComp.map.getContainer();
    mapContainer.style.position = 'relative';

    const popup = document.createElement('div');
    popup.id = 'instruction-top-left';

    popup.innerHTML = `
    
  `;

    popup.style.position = 'absolute';
    popup.style.top = '15px';
    popup.style.left = '15px';
    popup.style.zIndex = '9999';
    popup.style.pointerEvents = 'none';

    mapContainer.appendChild(popup);
  }

  setupPointClickHandler(gisMapComp) {
    if (gisMapComp.pointClickHandler) {
      gisMapComp.map.off('dblclick', gisMapComp.pointClickHandler);
    }

    gisMapComp.pointClickHandler = (e: any) => {
      if (!gisMapComp.isLocationOnlyMode) return;

      const lat = e.latlng.lat;
      const lng = e.latlng.lng;

      console.log(` Point double-clicked: ${lat}, ${lng}`);

      this.addTemporaryPointMarker(lat, lng, gisMapComp);
      gisMapComp.map.flyTo([lat, lng], 8, {
        duration: 1.5
      });
      this.queryHazardsByPoint(lat, lng, gisMapComp);
    };

    gisMapComp.map.on('dblclick', gisMapComp.pointClickHandler);
  }

  addTemporaryPointMarker(lat: number, lng: number, gisMapComp) {
    // Remove existing point marker if any
    if (gisMapComp.layers.overlaylayers['clickedPointMarker']) {
      gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers['clickedPointMarker']);
      delete gisMapComp.layers.overlaylayers['clickedPointMarker'];
    }

    // Create custom icon for point marker
    const pointIcon = L.divIcon({
      className: 'clicked-point-marker',
      html: `<div style="
        width: 16px;
        height: 16px;
        background: #4CAF50;
        border: 3px solid white;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);
        animation: pulse 1.5s infinite;
      "></div>`,
      iconSize: [16, 16],
      iconAnchor: [8, 8]
    });

    const marker = L.marker([lat, lng], { icon: pointIcon });
    marker.addTo(gisMapComp.map);
    gisMapComp.layers.overlaylayers['clickedPointMarker'] = marker;
  }

  queryHazardsByPoint(lat: number, lng: number, gisMapComp) {
    gisMapComp.showThrobber = true;

    const safetyTimeout = setTimeout(() => {
      gisMapComp.showThrobber = false;
      console.warn('Safety timeout - forcing throbber hide');
    }, 10000);

    this.clearAllConnectionLines(gisMapComp);

    // A slower response for an earlier double-click must not draw over the latest click's lines
    const requestSeq = gisMapComp.pointHazardRequestSeq = (gisMapComp.pointHazardRequestSeq || 0) + 1;

    const postData = {
      latitude: lat,
      longitude: lng,
      hazardTypes: ["EARTHQUAKE", "CYCLONE"]
    };

    this.getNearestHazardsByPoint(postData).subscribe(
      (hazardResponse: any) => {
        clearTimeout(safetyTimeout);
        if (requestSeq !== gisMapComp.pointHazardRequestSeq) return;
        console.log('Point hazard response:', hazardResponse);

        this.drawHazardConnectionLines(lat, lng, hazardResponse, gisMapComp);

        gisMapComp.gisUtils.pointHazardData.next({
          latitude: lat,
          longitude: lng,
          data: hazardResponse,
          services: null
        });

        gisMapComp.showThrobber = false;
      },
      (error: any) => {
        clearTimeout(safetyTimeout);
        if (requestSeq !== gisMapComp.pointHazardRequestSeq) return;
        gisMapComp.showThrobber = false;
        console.error('Error fetching point hazard data:', error);
      }
    );
  }

  drawHazardConnectionLines(lat: number, lng: number, hazardData: any, gisMapComp) {
    const clickPoint: [number, number] = [lat, lng];

    if (hazardData &&
      hazardData.hazards &&
      hazardData.hazards.earthquake &&
      hazardData.hazards.earthquake.nearestEarthquakePoint &&
      hazardData.hazards.earthquake.nearestEarthquakePoint.nearestPoint) {

      const eq = hazardData.hazards.earthquake.nearestEarthquakePoint;
      this.drawDottedLine(
        clickPoint,
        [eq.nearestPoint.latitude, eq.nearestPoint.longitude],
        '#FF9800',
        'earthquake',
        'earthquake',
        'EQ',
        gisMapComp,
        eq.distanceKm
      );
    }

    if (hazardData &&
      hazardData.hazards &&
      hazardData.hazards.cyclone &&
      hazardData.hazards.cyclone.nearestPoint) {

      const cyclone = hazardData.hazards.cyclone;
      this.drawDottedLine(
        clickPoint,
        [cyclone.nearestPoint.latitude, cyclone.nearestPoint.longitude],
        '#9C27B0',
        'cyclone',
        'cyclone',
        'Cyclone',
        gisMapComp,
        cyclone.distanceKm
      );
    }

    if (hazardData &&
      hazardData.hazards &&
      hazardData.hazards.earthquake &&
      hazardData.hazards.earthquake.nearestFaultLine &&
      hazardData.hazards.earthquake.nearestFaultLine.nearestPoint) {

      const fault = hazardData.hazards.earthquake.nearestFaultLine;
      this.drawDottedLine(
        clickPoint,
        [fault.nearestPoint.latitude, fault.nearestPoint.longitude],
        '#795548',
        'faultLine',
        'faultLine',
        'Fault',
        gisMapComp,
        fault.distanceKm
      );

      if (fault.geometry) {
        this.addFaultLineGeometry(fault.geometry, fault.faultName, gisMapComp);
      }
    }

    this.initHazardLabelLayout(clickPoint, gisMapComp);
  }
  drawDottedLine(from: [number, number], to: [number, number], color: string, type: string, layerType: string, label: string = '', gisMapComp, apiDistanceKm?: number) {
    const line = L.polyline([from, to], {
      color: color,
      weight: 2,
      opacity: 0.8,
      dashArray: '5, 10',
      lineJoin: 'round',
      className: `connection-line ${type}-line`
    }).addTo(gisMapComp.map);

    const midPoint: [number, number] = [(from[0] + to[0]) / 2, (from[1] + to[1]) / 2];
    const distance = apiDistanceKm !== undefined
      ? apiDistanceKm
      : this.calculateDistance(from[0], from[1], to[0], to[1]);
    const displayLabel = label ? `${label} · ${distance.toFixed(1)} km` : `${distance.toFixed(1)} km`;

    // iconSize null lets the label size to its text (measured later for collision checks); the inner
    // translate centres it on its latlng, which layoutHazardLabels moves to a non-overlapping spot
    const distanceLabel = L.marker(midPoint, {
      interactive: false,
      keyboard: false,
      zIndexOffset: 500,
      icon: L.divIcon({
        className: 'distance-label',
        html: `<div style="
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-50%, -50%);
        background: white;
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        border: 2px solid ${color};
        color: ${color};
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 4px;
      ">
        <span>${displayLabel}</span>
      </div>`,
        iconSize: null
      })
    }).addTo(gisMapComp.map);
    let endIcon;

    if (type === 'earthquake') {

      endIcon = L.marker(to, {
        icon: L.divIcon({
          className: 'earthquake-end-icon',
          html: `
        <div style="position: relative; width: 36px; height: 46px;">

          <!-- Ripple Rings (smaller) -->
          <div style="
            position:absolute;
            bottom:0;
            left:50%;
            transform:translateX(-50%);
            width:40px;
            height:12px;
            border-radius:50%;
            border:1.5px solid rgba(0,0,0,0.2);
          "></div>

          <div style="
            position:absolute;
            bottom:3px;
            left:50%;
            transform:translateX(-50%);
            width:30px;
            height:9px;
            border-radius:50%;
            border:1.5px solid rgba(0,0,0,0.2);
          "></div>

          <!-- Pin -->
          <svg width="28" height="38" viewBox="0 0 40 50"
               style="position:absolute; left:50%; transform:translateX(-50%);">

            <path d="M20 0
                     C9 0 0 9 0 20
                     C0 32 20 50 20 50
                     C20 50 40 32 40 20
                     C40 9 31 0 20 0 Z"
                  fill="#000"/>

            <circle cx="20" cy="18" r="10" fill="white"/>

            <polyline points="12,18 16,18 18,14 21,22 24,16 28,18"
                      fill="none"
                      stroke="black"
                      stroke-width="2"/>
          </svg>

        </div>
      `,
          iconSize: [36, 46],
          iconAnchor: [18, 38]
        })
      }).addTo(gisMapComp.map);

    }

    else {

      endIcon = L.marker(to, {
        icon: L.divIcon({
          className: `${type}-end-icon`,
          html: `<div style="
        width: 30px;
        height: 30px;
        background: white;
        border: 2px solid ${color};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        ${this.getIconForType(type)}
      </div>`,
          iconSize: [30, 30],
          iconAnchor: [15, 15]
        })
      }).addTo(gisMapComp.map);

    }


    if (!gisMapComp.connectionLines[layerType]) {
      gisMapComp.connectionLines[layerType] = [];
    }

    gisMapComp.connectionLines[layerType].push({
      line,
      label: distanceLabel,
      icon: endIcon,
      from,
      to,
      color,
      // Pixel box of the end icon relative to its latlng, matching the iconSize/iconAnchor above
      iconBox: type === 'earthquake' ? { left: 18, top: 38, right: 18, bottom: 8 } : { left: 15, top: 15, right: 15, bottom: 15 }
    });
  }

  // ---- Dynamic layout for point-click hazard labels/icons: keeps every label visible without overlaps,
  // recomputed in screen pixels after every zoom/pan/resize since overlap depends on the current zoom ----

  initHazardLabelLayout(clickPoint: [number, number], gisMapComp) {
    const map = gisMapComp.map;
    const items: any[] = [];
    ['earthquake', 'cyclone', 'faultLine'].forEach(key => {
      (gisMapComp.connectionLines[key] || []).forEach((item: any) => {
        if (item && item.label) items.push(item);
      });
    });
    if (!items.length) return;

    items.forEach(item => {
      const el = item.label.getElement();
      const box = el && el.firstElementChild as HTMLElement;
      item.labelSize = box && box.offsetWidth ? { w: box.offsetWidth, h: box.offsetHeight } : { w: 130, h: 26 };
    });

    const state: any = { click: clickPoint, items };
    // Hide labels/leaders while the zoom animates, then lay them out again at the new zoom
    state.onZoomStart = () => L.DomUtil.addClass(map.getContainer(), 'nhip-hazard-labels-hidden');
    state.onMoveEnd = () => {
      this.layoutHazardLabels(gisMapComp);
      L.DomUtil.removeClass(map.getContainer(), 'nhip-hazard-labels-hidden');
    };
    map.on('zoomstart', state.onZoomStart);
    map.on('moveend resize', state.onMoveEnd);
    gisMapComp.hazardLabelLayout = state;

    this.layoutHazardLabels(gisMapComp);

    // Fit all hazards in view so short connections get enough pixels; moveend re-runs the layout at the new zoom
    const bounds = L.latLngBounds([clickPoint, ...items.map(item => item.to)]).pad(0.3);
    map.flyToBounds(bounds, { maxZoom: 11, duration: 1.2 });
  }

  teardownHazardLabelLayout(gisMapComp) {
    const state = gisMapComp.hazardLabelLayout;
    if (!state) return;
    gisMapComp.map.off('zoomstart', state.onZoomStart);
    gisMapComp.map.off('moveend resize', state.onMoveEnd);
    L.DomUtil.removeClass(gisMapComp.map.getContainer(), 'nhip-hazard-labels-hidden');
    gisMapComp.hazardLabelLayout = null;
  }

  layoutHazardLabels(gisMapComp) {
    const state = gisMapComp.hazardLabelLayout;
    const map = gisMapComp.map;
    if (!state) return;
    const items = state.items.filter((item: any) => map.hasLayer(item.line));
    if (!items.length) return;

    const mapSize = map.getSize();
    const clickPx = map.latLngToContainerPoint(state.click);
    const obstacles: any[] = [this.rectAround(clickPx.x, clickPx.y, 12, 12)];

    this.spreadEndIcons(items, clickPx, gisMapComp);
    items.forEach(item => obstacles.push(this.iconRect(item)));

    const segments = items.map(item => ({ item, a: clickPx, b: map.latLngToContainerPoint(item.to) }));
    // Shortest connection first: it has the fewest free spots near its own line
    const ordered = segments.slice().sort((s1, s2) => s1.a.distanceTo(s1.b) - s2.a.distanceTo(s2.b));

    ordered.forEach(seg => {
      const { w, h } = seg.item.labelSize;
      let best: any = null;
      // Candidates are in preference order; take the first that collides with nothing, else the least-bad one
      for (const c of this.labelCandidates(seg.a, seg.b, w, h)) {
        const rect = this.rectAround(c.x, c.y, w / 2, h / 2);
        let cost = this.offscreenArea(rect, mapSize);
        obstacles.forEach(o => cost += this.overlapArea(rect, o, 4));
        segments.forEach(other => {
          if (other !== seg && this.segmentHitsRect(other.a, other.b, rect)) cost += 50;
        });
        if (!best || cost < best.cost) best = { cost, point: c, rect };
        if (cost === 0) break;
      }
      obstacles.push(best.rect);
      seg.item.label.setLatLng(map.containerPointToLatLng(best.point));
      this.updateLabelLeader(seg, best.rect, gisMapComp);
    });
  }

  labelCandidates(a: L.Point, b: L.Point, w: number, h: number): L.Point[] {
    const len = a.distanceTo(b);
    const dir = len > 1 ? b.subtract(a).divideBy(len) : L.point(1, 0);
    const normal = L.point(-dir.y, dir.x);
    // Half-extent of the label box along a unit vector, so offsets clear the line/icon at any line angle
    const extent = (u: L.Point) => Math.abs(u.x) * w / 2 + Math.abs(u.y) * h / 2;
    const step = extent(normal) + 6;
    const candidates: L.Point[] = [];

    // Along its own line, sliding sideways off it if needed
    [0.5, 0.65, 0.35, 0.8, 0.2].forEach(t => {
      const base = a.add(dir.multiplyBy(len * t));
      [0, 1, -1, 2, -2].forEach(k => candidates.push(base.add(normal.multiplyBy(k * step))));
    });
    // Just beyond the hazard's end icon
    candidates.push(b.add(dir.multiplyBy(24 + extent(dir))));
    // Two rings around the clicked point, starting in the line's direction
    [1, 3].forEach(ring => {
      for (let i = 0; i < 8; i++) {
        const angle = Math.atan2(dir.y, dir.x) + i * Math.PI / 4;
        const u = L.point(Math.cos(angle), Math.sin(angle));
        candidates.push(a.add(u.multiplyBy(18 + extent(u) * ring)));
      }
    });
    return candidates;
  }

  spreadEndIcons(items: any[], clickPx: L.Point, gisMapComp) {
    const map = gisMapComp.map;
    const points: L.Point[] = items.map(item => map.latLngToContainerPoint(item.to));

    // Cluster icons whose real positions are within 32px of each other
    const parent = items.map((_, i) => i);
    const root = (i: number): number => parent[i] === i ? i : (parent[i] = root(parent[i]));
    for (let i = 0; i < items.length; i++) {
      for (let j = i + 1; j < items.length; j++) {
        if (points[i].distanceTo(points[j]) < 32) parent[root(j)] = root(i);
      }
    }
    const clusters: { [key: number]: number[] } = {};
    items.forEach((_, i) => (clusters[root(i)] = clusters[root(i)] || []).push(i));

    Object.keys(clusters).forEach(key => {
      const members = clusters[key];
      const positions = members.map(i => points[i]);
      const mean = positions.reduce((sum, p) => sum.add(p), L.point(0, 0)).divideBy(positions.length);
      const nearClick = positions.some(p => p.distanceTo(clickPx) < 28);

      if (nearClick) {
        // Fan out on the side away from the clicked point so the click marker stays visible
        const away = mean.subtract(clickPx);
        const base = away.x || away.y ? Math.atan2(away.y, away.x) : -Math.PI / 2;
        members.forEach((_, k) => {
          const angle = base + (k - (members.length - 1) / 2) * 0.9;
          positions[k] = clickPx.add(L.point(Math.cos(angle), Math.sin(angle)).multiplyBy(40));
        });
      } else if (members.length > 1) {
        members.forEach((_, k) => {
          const angle = -Math.PI / 2 + k * 2 * Math.PI / members.length;
          positions[k] = mean.add(L.point(Math.cos(angle), Math.sin(angle)).multiplyBy(24));
        });
      }
      members.forEach((i, k) => this.placeEndIcon(items[i], positions[k], points[i], gisMapComp));
    });
  }

  placeEndIcon(item: any, pos: L.Point, truePos: L.Point, gisMapComp) {
    const map = gisMapComp.map;
    item.iconPx = pos;
    if (pos.distanceTo(truePos) > 1) {
      const iconLatLng = map.containerPointToLatLng(pos);
      item.icon.setLatLng(iconLatLng);
      // Leader from the displaced icon back to the real hazard location
      item.iconLeader = this.setLeader(item.iconLeader, [iconLatLng, item.to], item.color, gisMapComp);
    } else {
      item.icon.setLatLng(item.to);
      item.iconLeader = this.setLeader(item.iconLeader, null, item.color, gisMapComp);
    }
  }

  updateLabelLeader(seg: any, rect: any, gisMapComp) {
    const map = gisMapComp.map;
    const center = L.point((rect.x1 + rect.x2) / 2, (rect.y1 + rect.y2) / 2);
    const onLine = this.closestPointOnSegment(center, seg.a, seg.b);
    const edge = L.point(
      Math.min(Math.max(onLine.x, rect.x1), rect.x2),
      Math.min(Math.max(onLine.y, rect.y1), rect.y2)
    );
    // Once a label is pushed clear of its own line, a leader shows which line it belongs to
    const latlngs = edge.distanceTo(onLine) > 18
      ? [map.containerPointToLatLng(edge), map.containerPointToLatLng(onLine)]
      : null;
    seg.item.leader = this.setLeader(seg.item.leader, latlngs, seg.item.color, gisMapComp);
  }

  setLeader(leader: any, latlngs: any[], color: string, gisMapComp) {
    if (!latlngs) {
      if (leader) gisMapComp.map.removeLayer(leader);
      return null;
    }
    if (leader) {
      leader.setLatLngs(latlngs);
      return leader;
    }
    return L.polyline(latlngs, {
      color: color,
      weight: 1.5,
      opacity: 0.9,
      interactive: false,
      className: 'hazard-leader-line'
    }).addTo(gisMapComp.map);
  }

  iconRect(item: any) {
    const p = item.iconPx, box = item.iconBox;
    return { x1: p.x - box.left, y1: p.y - box.top, x2: p.x + box.right, y2: p.y + box.bottom };
  }

  rectAround(x: number, y: number, halfW: number, halfH: number) {
    return { x1: x - halfW, y1: y - halfH, x2: x + halfW, y2: y + halfH };
  }

  overlapArea(r: any, o: any, pad: number): number {
    const w = Math.min(r.x2, o.x2 + pad) - Math.max(r.x1, o.x1 - pad);
    const h = Math.min(r.y2, o.y2 + pad) - Math.max(r.y1, o.y1 - pad);
    return w > 0 && h > 0 ? w * h : 0;
  }

  offscreenArea(r: any, size: L.Point): number {
    const margin = 4;
    const visW = Math.max(0, Math.min(r.x2, size.x - margin) - Math.max(r.x1, margin));
    const visH = Math.max(0, Math.min(r.y2, size.y - margin) - Math.max(r.y1, margin));
    return ((r.x2 - r.x1) * (r.y2 - r.y1) - visW * visH) * 2;
  }

  closestPointOnSegment(p: L.Point, a: L.Point, b: L.Point): L.Point {
    const ab = b.subtract(a);
    const len2 = ab.x * ab.x + ab.y * ab.y;
    if (!len2) return a;
    const t = Math.max(0, Math.min(1, ((p.x - a.x) * ab.x + (p.y - a.y) * ab.y) / len2));
    return a.add(ab.multiplyBy(t));
  }

  // Liang–Barsky clip: does segment a-b pass through rect r
  segmentHitsRect(a: L.Point, b: L.Point, r: any): boolean {
    let t0 = 0, t1 = 1;
    const dx = b.x - a.x, dy = b.y - a.y;
    const checks = [[-dx, a.x - r.x1], [dx, r.x2 - a.x], [-dy, a.y - r.y1], [dy, r.y2 - a.y]];
    for (const [p, q] of checks) {
      if (p === 0) {
        if (q < 0) return false;
      } else {
        const t = q / p;
        if (p < 0) {
          if (t > t1) return false;
          if (t > t0) t0 = t;
        } else {
          if (t < t0) return false;
          if (t < t1) t1 = t;
        }
      }
    }
    return true;
  }

  addFaultLineGeometry(geometry: string, faultName: string, gisMapComp) {
    try {
      const coordinates = this.parseMultiLineString(geometry);

      const faultLine = L.polyline(coordinates, {
        color: '#795548',
        weight: 2,
        opacity: 0.6,
        className: 'fault-line-geometry'
      }).addTo(gisMapComp.map);

      faultLine.bindPopup(`<strong>Fault Line:</strong> ${faultName}`);

      if (!gisMapComp.connectionLines.faultGeometry) {
        gisMapComp.connectionLines.faultGeometry = [];
      }
      gisMapComp.connectionLines.faultGeometry.push(faultLine);
    } catch (e) {
      console.error('Error parsing fault line geometry:', e);
    }
  }

  parseMultiLineString(wkt: string): [number, number][] {
    const match = wkt.match(/MULTILINESTRING\(\((.*)\)\)/);
    if (!match) return [];

    const points = match[1].split(',');
    return points.map(point => {
      const [lng, lat] = point.trim().split(' ').map(Number);
      return [lat, lng];
    });
  }

  getIconForType(type: string): string {
    const icons: { [key: string]: string } = {
      'school': '🏫',
      'hospital': '🏥',
      'earthquake': '⚡',
      'cyclone': '🌀',
      'faultLine': '🔴'
    };
    return icons[type] || '📍';
  }

  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371;
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  addPointMarkerStyles() {
    // Injected globally because Leaflet creates these elements outside the component's encapsulated styles
    if (document.getElementById('nhip-point-marker-styles')) return;
    const style = document.createElement('style');
    style.id = 'nhip-point-marker-styles';
    style.textContent = `
      .distance-label {
        pointer-events: none;
        transition: opacity 0.2s;
      }
      .hazard-leader-line {
        transition: opacity 0.2s;
      }
      .nhip-hazard-labels-hidden .distance-label,
      .nhip-hazard-labels-hidden .hazard-leader-line {
        opacity: 0;
      }
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.5); opacity: 0.7; }
        100% { transform: scale(1); opacity: 1; }
      }
      .clicked-point-marker {
        z-index: 1000 !important;
      }
      .leaflet-control-location-exit {
        background: white;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      }
    `;
    document.head.appendChild(style);
  }

  animateCycloneLines(layer: any, map: L.Map, params: any, gisMapComp: any) {
    let animateLayer = new (L as any).LayerGroup();
    layer.setStyle(this.getStyle('#0303FF', 'popUp'))
    var clonedLayer = cloneLayer(layer);
    clonedLayer.setStyle(this.getClonedLayerStyle('#000000', 'popup'));
    animateLayer.addLayer(clonedLayer);
    layer.setStyle({
      className: "directiveReverseAnimation"
    })

    layer.on({
      click: (e: L.LayerEvent) => {
        // let canal = e.target.feature.properties['canal_name'], features = e.target.feature.properties['canal_name'];
        // urlParams['pUUID'] = features['uuid'];
        // urlParams['locName'] = canal;
      }
    });
    animateLayer.addLayer(layer);
    return animateLayer;
  }

  getStyle(color: any, custompane: any) {
    return {
      pane: custompane,
      color: color,
      opacity: 1,
      weight: 1.5,
      dashArray: "8 10",
    }
  }

  getClonedLayerStyle(color: any, pane: any) {
    return {
      //  color:color,
      pane: pane,
      //  opacity:1,
      //  weight : 3,
      //  dashArray:"10 15",
      color: color,
      opacity: 1,
      dashArray: "0"
    }
  }

}
